import React, { useRef, useEffect } from 'react';
import { ListItem, ListItemButton, ListItemIcon, ListItemText, useTheme, GlobalStyles } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useCello } from '../../context/CelloContext';

interface ReferralButtonProps {}

const ReferralButton: React.FC<ReferralButtonProps> = () => {
  const { isCelloBooted } = useCello();
  const { t } = useTranslation();
  const theme = useTheme();
  const buttonRef = useRef<HTMLLIElement>(null);

  useEffect(() => {
    if (buttonRef.current) {
      // The 'cello' attribute might be for Cello SDK to find/style the button.
      // We keep it here, assuming CelloInitializer makes it visible.
      buttonRef.current.toggleAttribute('cello', true);
    }
  }, []);

  // Control overall rendering based on Cello's boot status from context
  if (!isCelloBooted) {
    return null; // Don't render the button if Cello is not booted
  }

  const celloWidgetStyles = {
    // Target the direct parent of .cello-1qoplec
    ':has(> .cello-1qoplec)': {
      position: 'relative',
    },
    '.cello-1qoplec': {
      position: 'absolute',
      bottom: '10px !important',
      top: 'unset !important',
      right: 'unset !important',
      left: 'unset !important',
    },
  };

  return (
    <>
      <GlobalStyles styles={celloWidgetStyles} />
      <ListItem 
        ref={buttonRef}
        disablePadding 
        sx={{ borderRadius: 1, mb: 0.5 }}
        id="celloLauncher"
        className="celloLauncher"
      >
        <ListItemButton
          sx={{
            borderRadius: 1,
            py: 0.75,
            px: 1.5,
            backgroundColor: theme.palette.primary.main,
            color: '#ffffff',
            '&:hover': {
              backgroundColor: theme.palette.primary.dark,
              color: '#ffffff',
            },
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 34,
              color: '#ffffff',
              '& img': {
                width: '1.4rem',
                height: '1.4rem',
              },
            }}
          >
            <img src="/assets/icons/share2.svg" alt={t('referral.inviteFriends')} />
          </ListItemIcon>
          <ListItemText
            primary={t('referral.inviteFriends')}
            slotProps={{
              primary: {
                sx: {
                  fontSize: '0.875rem',
                  fontWeight: 600,
                  letterSpacing: '0.01em',
                  whiteSpace: 'pre-line',
                  lineHeight: 1.4,
                },
              },
            }}
          />
        </ListItemButton>
      </ListItem>
    </>
  );
};

export default ReferralButton;
